import React from 'react';
import { ConditionalWrapperProps } from './types';

export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = (props) => {
  const { condition, wrapper, children } = props;
  return <>{condition ? wrapper(children) : children}</>;
};

export default ConditionalWrapper;
